__webpack_require__.p = `${acConfig.containerFrontendUrl}/`;